/**
 * Acceso a vista Egresos / Subir comprobantes de pago.
 * iderp: 31 Angel Lopez, 568 María Esther Segura, 1312 Paola Zuyin Rodríguez,
 * 2548 Valeria Monroy Silva.
 */
export const IDERPS_EGRESOS_COMPROBANTES = [31, 568, 1312, 2548]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

/**
 * Inyecta Egresos y SubirMisEgresos en el menú si el usuario está en la allowlist
 * y aún no los tiene (permiso de puesto incompleto).
 */
export function asegurarMenuEgresosComprobantes(menu, iderp) {
  if (!IDERPS_EGRESOS_COMPROBANTES.includes(Number(iderp))) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  const pathsNeeded = [
    { path: 'Egresos', title: 'Egresos' },
    { path: 'SubirMisEgresos', title: 'Subir Mis comprobantes' },
  ]

  let target = list.find((m) => Number(m.idmenu) === 13)
  if (!target) {
    target = { title: 'Contabilidad / Egresos', idmenu: 13, path: null, items: [] }
    list.push(target)
  }
  if (!Array.isArray(target.items)) target.items = []

  for (const a of pathsNeeded) {
    if (!menuTienePath(list, a.path)) {
      target.items.push({
        title: a.title,
        path: a.path,
        icon: 'mdi mdi-cash-multiple',
        active: 1,
      })
    }
  }
  return list
}
